<nav>
  <div class="logo">
    <a routerLink="/">
      <img src="assets/static/icons/rfebm-logo.svg" alt="Logo" />
    </a>
  </div>
  <div class="nav-links">
    @for (navLink of navbarLinks; track $index) {
    <div class="nav-link" [ngClass]="{ active: isCurrentRoute(navLink.route) }">
      <div class="icon">
        <img [src]="navLink.iconPath" alt="{{ navLink.label }} icon" />
      </div>
      <a [routerLink]="navLink.route">
        {{ navLink.label }}
      </a>
    </div>
    }
  </div>
  <div class="user-actions">
    <div
      class="user-action profile"
      [ngClass]="{ active: isCurrentRoute('/profile') }"
    >
      <a [routerLink]="['/profile']">
        {{ user?.name || user?.loginName || user?.email || "Yo" }}
      </a>
    </div>
    <div class="user-action">
      <a [routerLink]="['/logout']">
        <img src="assets/static/icons/logout.svg" alt="Logout icon" />
      </a>
    </div>
  </div>
</nav>
